import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { BudgetControlHistory } from './budgetcontrol.models';
import BudgetControlStatusChip from './BudgetControlStatusChip';

const money = (value: number, currency: string) =>
  new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: currency || 'XOF',
    maximumFractionDigits: 0,
  }).format(value || 0);

const date = (value?: string | null) =>
  value
    ? new Intl.DateTimeFormat('en-GB', {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(new Date(value))
    : '—';

export default class BudgetControlHistoryGrid extends React.PureComponent<{rows:BudgetControlHistory[]}> {

  private columns=():GridColDef<BudgetControlHistory>[]=>[
    {field:'versionno',headerName:'Version',width:90,valueFormatter:(v:any)=>`V${Number(v||0)}`},
    {field:'capacitysourcename',headerName:'Capacity Source',minWidth:190,flex:1},
    {field:'capacityamount',headerName:'Capacity',width:175,valueFormatter:(v:any)=>money(Number(v||0),'XOF')},
    {field:'allocatedpercent',headerName:'Distributed',width:120,valueFormatter:(v:any)=>`${Number(v||0).toFixed(2)}%`},
    {field:'bufferpercent',headerName:'Buffer',width:105,valueFormatter:(v:any)=>`${Number(v||0).toFixed(2)}%`},
    {field:'statecode',headerName:'State',width:175,renderCell:(p:any)=><BudgetControlStatusChip stateCode={String(p.value||'')} current={Number(p.row.iscurrent)===1}/>},
    {field:'created',headerName:'Created',width:175,valueFormatter:(v:any)=>date(v)},
    {field:'activatedat',headerName:'Activated',width:175,valueFormatter:(v:any)=>date(v)},
  ];

  render() {
    return (
      <FDataGrid
        rows={this.props.rows}
        columns={this.columns()}
        title="Budget Control History"
        subtitle="Governed version history and capacity lineage for this Planning Cycle."
        height={330}
        getRowId={(r: BudgetControlHistory) => r.budgetcontrolid}
        pageSizeOptions={[10, 25, 50]}
      />
    );
  }
}

